import React, { useEffect, useState } from 'react';
import { auth } from '@/firebase/config';
import { onAuthStateChanged } from 'firebase/auth';

const AuthTest: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<any>(null);
  
  useEffect(() => {
    console.log('🔍 Checking Firebase Auth state...');
    console.log('Auth object:', auth);
    
    if (!auth) {
      console.error('❌ Auth is null/undefined');
      return;
    }
    
    // Check initial state
    console.log('🔍 Initial auth.currentUser:', auth.currentUser);
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('🔄 Auth state changed:', user ? 'User logged in' : 'User logged out');
      setCurrentUser(user);
      
      if (user) {
        console.log('✅ User is authenticated:', {
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          photo: user.photoURL
        });
      } else {
        console.log('❌ User is NOT authenticated');
      }
    });
    
    return () => unsubscribe();
  }, []);
  
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Authentication Test</h2>
      <div className="bg-gray-50 p-4 rounded-lg space-y-2">
        <p className="text-sm">
          <span className="font-medium">Auth object:</span> {auth ? '✅ Initialized' : '❌ Not initialized'}
        </p>
        <p className="text-sm">
          <span className="font-medium">Current user (state):</span> {currentUser ? `✅ ${currentUser.email}` : '❌ No user'}
        </p>
        <p className="text-sm">
          <span className="font-medium">Current user (auth):</span> {auth?.currentUser ? `✅ ${auth.currentUser.email}` : '❌ No user'}
        </p>
      </div>
      {currentUser && (
        <div className="mt-4 bg-green-50 p-4 rounded-lg">
          <h3 className="font-semibold mb-2">User Details:</h3>
          <ul className="text-sm space-y-1">
            <li>UID: {currentUser.uid}</li>
            <li>Email: {currentUser.email}</li>
            <li>Name: {currentUser.displayName || 'Not set'}</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default AuthTest;

